import { StepType } from '../../main/types/asset/asset.enums.ts';
import { createMemoizedSelector } from '../../main/utils/selector/create-memoized-selector.ts';

import { selectCurrentLessonTaskStep } from './current-lesson-task-step.selector.ts';

export const selectCurrentUserSentence = createMemoizedSelector(
  selectCurrentLessonTaskStep,
  ({ task, step }): string => {
    if (!task.story) return '';

    const startIndex = step.startIndex ?? 0;
    const transitionIndex = step.transitionIndex;
    const storyIndex = step.index ?? 0;
    const currentSentence = task.story[storyIndex];

    if (!currentSentence) return '';

    switch (step.stepType) {
      case StepType.UserReadSentence:
        // For UserReadSentence, read from startIndex to end of sentence
        return currentSentence.slice(startIndex).join(' ');

      case StepType.BothReadSentence:
        // For BothReadSentence, read from transitionIndex to end of sentence
        return currentSentence.slice(transitionIndex).join(' ');

      default:
        // For all other types, return full sentence
        return currentSentence.join(' ');
    }
  }
);
